import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "../../../helpers/FormHelper";
import { createServer } from "../../../actions/mine_craft/serversActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams } from "../../../store/mine_craft/serversSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const newParams  = useAppSelector(state => state.mineCraft.servers.newParams);
  const error = useAppSelector(state => state.mineCraft.servers.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(rawData: any) {
    const formData = objToFormData(rawData);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createServer(data));

    if (createServer.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-server'>
        <h6 className="v-content-label">Create Server</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} allowHosted />
      </div>
    </DrawerRight>
  )
}

export default New;
